$(document).ready(function () {

	$(".product-list--carousel").each(function () {
		$(this).find(".carousel--wrap").slick({
			slidesToShow: 9,
			slidesToScroll: 1,
			arrows: true,
			respondTo: 'min',
			responsive: [
				{
					breakpoint: 3150,
					settings: {
						slidesToShow: 6
					}
				},
				{
					breakpoint: 2900,
					settings: {
						slidesToShow: 5.5
					}
				},
				{
					breakpoint: 2650,
					settings: {
						slidesToShow: 5
					}
				},
				{
					breakpoint: 2400,
					settings: {
						slidesToShow: 4.5
					}
				},
				{
					breakpoint: 2150,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 1900,
					settings: {
						slidesToShow: 3.5
					}
				},
				{
					breakpoint: 1650,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 2.5
					}
				},
				{
					breakpoint: 1150,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 950,
					settings: {
						slidesToShow: 1.5
					}
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	});
	if ($(".product-detail--kolo .product__detail__gallery .gallery-image").length > 1) {
		$(".product-detail--kolo .product__detail__gallery .carousel--wrap").slick({
			slidesToShow: 1,
			arrows: true
		});
	} else {
		$(".product__detail__gallery").find(".carousel--next, .carousel--prev").hide();
	}
});

